import classNames              from 'classnames';
import * as React              from 'react';
import { useTranslation }      from 'react-i18next';
import { Link }                from 'react-router-dom';
import { LocalStorageService } from 'ts-storage-service';

import './style.scss';

import deleteCookiesBasedOnPreferences from '../../common/tools/deleteCookiesBasedOnPreferences';
import notifyCookieConsentChanged      from '../../common/tools/notifyCookieConsentChanged';
import Preloader                       from '../../components/containers/preloader';
import Meta                            from '../../components/meta';
import PageHeader                      from '../../components/pageHeader';
import { useCommon }                   from '../../providers/common';

import CookieCheckbox from './components/CookieCheckbox';

const CookieSettings = function() {
  const { t } = useTranslation();

  const common = useCommon();

  const ls = new LocalStorageService('cookie');

  const [cookieSettings, setCookieSettings] = React.useState({
    analytical_cookie: false,
    marketing_cookie:  false,
    technical_cookie:  true,
  });

  const page = React.useMemo(() => {
    return common.pages.find((page) => page.template === 'cookie-settings');
  }, [common.pages]);

  const handleClick = React.useCallback((isAccept) => {
    const currentDate    = new Date();
    const oneYearFromNow = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

    if (isAccept) {
      ls.setData('settings', cookieSettings, oneYearFromNow);
    } else {
      ls.setData('settings', {
        technical_cookie:  false,
        analytical_cookie: false,
        marketing_cookie:  false,
      }, oneYearFromNow);
    }

    deleteCookiesBasedOnPreferences();

    ls.setData('accept', true, oneYearFromNow);
    notifyCookieConsentChanged();
  }, [cookieSettings]);

  React.useEffect(() => {
    if (ls.hasData('settings')) {
      setCookieSettings(ls.getData('settings'));
    }

    scrollTo({
      top:      0,
      left:     0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <>
      <div className={'page-content'}>
        <Meta {...page?.meta} />
        <PageHeader>{page.label}</PageHeader>
        <section className={'cookie_settings'}>
          <div
            className={'description_wrapper'}
          >
            <p>
              {t('cookie-settings.description.before_choice_cookie_settings')}
              {' '}
              <Link
                to={common.getUrlByTemplate('cookies-policy')}
                target={'_blank'}
              >
                {t('cookie-settings.description.cookie_policy')}
              </Link>
              {' '}
              {t('cookie-settings.description.and_also_with')}
              {' '}
              <Link
                to={common.getUrlByTemplate('cookies-list')}
                target={'_blank'}
              >
                {t('cookie-settings.description.cookies_list')}
              </Link>
              {' '}
              {t('cookie-settings.description.processed_on_site')}
            </p>
          </div>
          <div className={'checkbox_wrapper'}>
            <CookieCheckbox
              description={t('cookie-settings.technical_description')}
              id={'technical_cookie'}
              isChecked={true}
              isDisabled
              setIsChecked={setCookieSettings}
              title={t('cookie-settings.technical_title')}
            />
            <CookieCheckbox
              description={t('cookie-settings.analytical_description')}
              id={'analytical_cookie'}
              isChecked={cookieSettings['analytical_cookie']}
              setIsChecked={setCookieSettings}
              title={t('cookie-settings.analytical_title')}
            />
            <CookieCheckbox
              description={t('cookie-settings.marketing_description')}
              id={'marketing_cookie'}
              isChecked={cookieSettings['marketing_cookie']}
              setIsChecked={setCookieSettings}
              title={t('cookie-settings.marketing_title')}
            />
          </div>
          <div className={'btn_wrapper'}>
            <Link
              className={classNames('btn', 'fill')}
              to={'/'}
              onClick={() => handleClick(true)}
            >{t('btn_accept')}</Link>
            <Link
              className={classNames('btn', 'primary')}
              to={'/'}
              onClick={() => handleClick(false)}
            >{t('btn_decline')}</Link>
          </div>
        </section>
      </div>
      {common.loading && <Preloader />}
    </>
  );
};

export default CookieSettings;